// extracted by mini-css-extract-plugin
module.exports = {"HeaderContainer":"Gallery_HeaderContainer__3GGip","majorContainer":"Gallery_majorContainer__2hvDT"};